// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs":"2213ef1bee74602e","node_modules_userpilot_lib_index_js":"afb3b35c19bad2ce","apps_shells_suite-shell_src_bootstrap_ts":"948991e07522df7f","default-apps_shells_suite-shell_src_app_client_client_module_ts":"398d487706f6e8d5"}[chunkId] + ".js";
};